import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getWeightSettings } from 'actions/EntityActions';
import LOOKUP from 'constants/lookup';
import { measurementListCrumb } from 'utils/breadcrumbInfo';
import WithRouter from 'custom/withRouter';
// Basic Components
import Button from 'screens/components/basic/Button';
import Panel from 'screens/components/basic/Panel';
import PageHeaderWithButton from 'screens/components/basic/PageHeaderWithButton';
import GenericTable from 'screens/components/advanced/GenericTable';
import Grid from 'screens/components/basic/Grid';

class MeasurementList extends Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.props.getWeightSettings();
    }

    redirectToAddWeightSetting = () => {
        this.props.navigate("/manage/measurement/add");
    }

    redirectToEditWeightSetting = (id) => {
        this.props.navigate(`/manage/measurement/edit/${id}`);
    }

    render() {
        const listWeightsSettings = (this.props.weightSettings || []).map((item) => {
            return {
                ID: (<Link className="edit-link" to={`/manage/measurement/edit/${item.id}`}>{item.id}</Link>),
                Name: (<Link to={`/manage/measurement/edit/${item.id}`}>{item.name}</Link>),
                Weight: item.weight.toFixed(1) + " g",
                Status: (item.status !== "Active" ? <p className="statusIconRed m-0">{item.status}</p> :
                    <p className="statusIconGreen m-0">{item.status}</p>),
                Icons: (
                    <div>
                        <Button
                            type="IconEditButton"
                            mini={true}
                            onTouchTap={() => this.redirectToEditWeightSetting(item.id)} />
                    </div>
                )
            };
        });


        return (
            <Grid headerContent={measurementListCrumb}>
                <PageHeaderWithButton title={LOOKUP.menu.manage.items.weight.text}>
                    <Button
                        type="AddButton"
                        mini={true}
                        className="bg-light-green"
                        label={LOOKUP.weight.controls.addNewButton}
                        onTouchTap={() => this.redirectToAddWeightSetting()}
                    />
                </PageHeaderWithButton>
                <GenericTable
                    multiSelectable={false}
                    enableSelectAll={false}
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                    displayRowCheckbox={false}
                    selectable={false}
                    columns={LOOKUP.weight.tableColumns}
                    rows={listWeightsSettings}
                    stripedRows={true}
                />
            </Grid>
        );
    }
}

function mapStatetoProps(state) {
    return {
        weightSettings: state.entity.weightSettingsList
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getWeightSettings: () => dispatch(getWeightSettings())
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(WithRouter(MeasurementList));